/**
 * Feed Permission Constants for Community Feeds feature.
 * Mirrors FeedPermission.java / FeedPermissionConstants for use with
 * PermissionControl and isPermitted in the Feeds module.
 *
 * These values must match the permission names stored in the backend.
 */

// Feed Management Permissions
export const FEED_VIEW = 'Feed_View';
export const FEED_VIEW_EXTERNAL = 'Feed_View_External';
export const FEED_VIEW_PUBLIC_NON_MEMBER = 'Feed_View_Public_Non_Member';
export const FEED_CREATE = 'Feed_Create';
export const FEED_UPDATE = 'Feed_Update';
export const FEED_JOIN = 'Feed_Join';
export const FEED_LEAVE = 'Feed_Leave';
export const FEED_SHUTDOWN = 'Feed_Shutdown';

// Feed Visibility & Access Permissions
export const FEED_SET_CONFIDENTIAL = 'Feed_Set_Confidential';
export const FEED_REMOVE_CONFIDENTIAL = 'Feed_Remove_Confidential';

// Feed Message Management Permissions
export const FEED_MESSAGE_CREATE = 'Feed_Message_Create';
export const FEED_MESSAGE_DELETE = 'Feed_Message_Delete';

// Feed Announcement Permissions
export const FEED_ANNOUNCEMENT_CREATE = 'Feed_Announcement_Create';
export const FEED_ANNOUNCEMENT_TARGET = 'Feed_Announcement_Target';
export const FEED_ANNOUNCEMENT_DELETE = 'Feed_Announcement_Delete';
export const FEED_ANNOUNCEMENT_VIEW_ALL = 'Feed_Announcement_View_All';
export const FEED_ANNOUNCEMENT = 'Feed_Announcement_View';

// Feed Attachment Permissions
export const FEED_ATTACHMENT_CREATE = 'Feed_Attachment_Create';

// Channel Specific Permissions
export const FEED_CHANNEL_VIEW = 'Feed_Channel_View';

// Administrative Permissions
export const FEED_AUDIT = 'Feed_Audit';

export default {
  FEED_VIEW,
  FEED_VIEW_EXTERNAL,
  FEED_VIEW_PUBLIC_NON_MEMBER,
  FEED_CREATE,
  FEED_UPDATE,
  FEED_JOIN,
  FEED_LEAVE,
  FEED_SHUTDOWN,
  FEED_SET_CONFIDENTIAL,
  FEED_REMOVE_CONFIDENTIAL,
  FEED_MESSAGE_CREATE,
  FEED_MESSAGE_DELETE,
  FEED_ANNOUNCEMENT_CREATE,
  FEED_ANNOUNCEMENT_TARGET,
  FEED_ANNOUNCEMENT_DELETE,
  FEED_ANNOUNCEMENT_VIEW_ALL,
  FEED_ATTACHMENT_CREATE,
  FEED_CHANNEL_VIEW,
  FEED_AUDIT,
  FEED_ANNOUNCEMENT
};
